/// <amd-module name="TFS/Admin/Common/Controls/UsersListDialog/UsersListDialog" />
import React = require("react");

import AdminResources = require("TFS/Admin/Common/Controls/Resources");
import { Dialog } from "VSSUI/Dialog";

import { UsersListComponent } from "TFS/Admin/Common/Controls/UsersListDialog/UsersListComponent";
import { VssComponent } from "VSS/Platform/Layout";
import { IUsersListDialogComponentProps } from "TFS/Admin/Common/Controls/UsersListDialog/UserListDialog.props";

export class UsersListDialog extends VssComponent<IUsersListDialogComponentProps> {
    public render(): JSX.Element {
        return (
            <Dialog
                calloutContentClassName="user-dialog"
                onDismiss={this.props.onClose}
                footerButtonProps={[
                    {
                        onClick: this.props.onClose,
                        text: AdminResources.Close
                    }
                ]}
                titleProps={{ text: this.props.title || AdminResources.DefaultTitle, className: "body-xl" }}
            >
                <div>
                    <UsersListComponent
                        pageContext={this.props.pageContext}
                        users={this.props.users}
                        avatarSize={this.props.avatarSize ? this.props.avatarSize : "large"}
                        canDeleteMember={this.props.canDeleteMember}
                        onDeleteMember={this.props.onDeleteMember}
                    />
                </div>
            </Dialog>
        );
    }
}

VssComponent.register("ms.vss-admin-web.users-list-dialog", UsersListDialog);
